import { Box } from '@material-ui/core';

import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';

import { Text } from '../../../../../../shared/components/Text';
import { PayoutsListRowProps } from '../../../types/PayoutsListRowProps';

export const lenderFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'lender',
    align: 'center',
    sortable: false,
    headerName: (
      <Box textAlign={'center'}>
        <Text tId={'ENTITY'} />
      </Box>
    ),
    renderCell: (rowData: PayoutsListRowProps) => (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {LenderIcon({ lenderName: rowData.row.lender })}
      </div>
    ),
  };
};
